import { useMemo } from "react";
import { dataTableFeatures } from "./features";
export function useTableConfig(options) {
    const { data, columns, sorting, columnFilters, columnVisibility, rowSelection, globalFilter, pagination, expanded, grouping, enablePagination, enableSorting, enableGlobalFilter, enableColumnFilters, enableColumnVisibility, enableRowSelection, enableExpanding, enableGrouping, setSorting, setPagination, setColumnFilters, setColumnVisibility, setRowSelection, setGlobalFilter, setExpanded, getRowCanExpand } = options;
    // TanStack's auto filter for strings is a substring match, so "active"
    // would also match "inactive". Select filters compare the whole value.
    // Memoized apart from the config: TanStack rebuilds every column when the
    // array identity changes.
    const selectAwareColumns = useMemo(()=>columns.map((column)=>column.meta?.filterType === "select" && !column.filterFn ? {
                ...column,
                filterFn: "equalsStringSensitive"
            } : column), [
        columns
    ]);
    return useMemo(()=>{
        const config = {
            features: dataTableFeatures,
            data,
            columns: selectAwareColumns,
            manualPagination: !enablePagination,
            manualSorting: !enableSorting,
            manualFiltering: !(enableGlobalFilter || enableColumnFilters),
            state: {
                sorting,
                columnFilters,
                columnVisibility,
                rowSelection,
                globalFilter,
                ...enablePagination && {
                    pagination
                },
                ...(enableExpanding || enableGrouping) && {
                    expanded
                },
                ...enableGrouping && {
                    grouping
                }
            },
            // Rows and groups stay expanded across data refetches; without this, TanStack
            // resets `expanded` to its initial value on every `data` change and collapses
            // everything.
            autoResetExpanded: false,
            autoResetPageIndex: false
        };
        if (enablePagination) {
            config.onPaginationChange = setPagination;
        }
        if (enableSorting) {
            config.onSortingChange = setSorting;
        }
        if (enableGlobalFilter) {
            config.onGlobalFilterChange = setGlobalFilter;
        }
        if (enableColumnFilters) {
            config.onColumnFiltersChange = setColumnFilters;
        }
        if (enableColumnVisibility) {
            config.onColumnVisibilityChange = setColumnVisibility;
        }
        if (enableRowSelection) {
            config.onRowSelectionChange = setRowSelection;
            config.enableRowSelection = true;
        }
        if (enableExpanding || enableGrouping) {
            config.onExpandedChange = setExpanded;
        }
        if (enableExpanding) {
            config.getRowCanExpand = getRowCanExpand ?? (()=>true);
        }
        return config;
    }, [
        data,
        selectAwareColumns,
        sorting,
        columnFilters,
        columnVisibility,
        rowSelection,
        globalFilter,
        pagination,
        enablePagination,
        enableSorting,
        enableGlobalFilter,
        enableColumnFilters,
        enableColumnVisibility,
        enableRowSelection,
        enableExpanding,
        enableGrouping,
        expanded,
        grouping,
        setSorting,
        setPagination,
        setColumnFilters,
        setColumnVisibility,
        setRowSelection,
        setGlobalFilter,
        setExpanded,
        getRowCanExpand
    ]);
}

//# sourceMappingURL=useTableConfig.js.map